module.exports = __webpack_public_path__ + "static/media/ZUTC6.ef6c3cd1.pdf";